
import axios from "axios";

const svrUrl = process.env.REACT_APP_SERVER_URL;//svrUrl = 'http://localhost:8000';

// async function getS3Path(imagePath, sec=60000) {
//   try {
//     const imgUrl = await fetchImageUrl(imagePath, sec);
//     return imgUrl;
//   } catch (error) {
//     console.error('Error in getImgUrl:', error);
//   }
// }


async function getS3Path(imagePath, sec=60000) {
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



async function getS3PathDownLoad_rename(imagePath, fileName, sec=600) {
  // const imagePath = 'bbb.jpeg'; // 서버에 요청할 파일 이름
  try {
    const imgUrl = await fetchImageUrl_rename(imagePath, fileName, sec);
    return imgUrl;
  } catch (error) {
    console.error('Error in getImgUrl:', error);
  }
}


async function fetchImageUrl_rename(imagePath, fileName, sec) {
  const url = `${svrUrl}/get-image-path-rename`;
  try {
    const response = await axios.post(url, {
      imagePath: imagePath,
      fileName: fileName,
      sec: sec
    });
    if (response.data.url) {
      return response.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}


// async function fetchImageUrl_rename(imagePath, fileName, sec) {

//   try {
//     const response = await axios.get(`http://localhost:8000/get-image-path-rename`, {
//       params: { imagePath, fileName, sec } // 쿼리 파라미터로 imagePath 전달
//     });
//     if (response.data.url) {
//       return response.data.url; // 성공적으로 URL 반환
//     } else {
//       return ''; // URL이 없는 경우 빈 문자열 반환
//     }
//   } catch (error) {
//     console.error('Error fetching image URL:', error);
//     return ''; // 오류 발생 시 빈 문자열 반환
//   }
// }



async function getS3PathLong(imagePath, sec=600) {
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}


async function getS3PathShort(imagePath, sec=1) {
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



async function getS3PathVideo(imagePath, sec=60000) {
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



//GET방식은 param값을 서버에서 못 가져와서 POST 방식으로 변경
async function fetchImageUrl(imagePath, sec) {
  // const url = `https://kuebs.org/api/get-image-path`;//서버일 때 (proxy)
  // const url = `http://localhost:8000/get-image-path`;//로컬일 때
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}


// 파일을 Presigned URL로 직접 업로드하는 함수
async function axiosPutFile(url, file) {
  try {
    const response = await axios.put(url, file, {
      headers: {
        'Content-Type': file.type
      }
    });
    return response;
  } catch (error) {
    console.error('axiosPutFile 업로드 실패:', error);
    throw error;
  }
}



// async function fetchImageUrl(imagePath, sec) {
//   const url = `https://kuebs.org/api/get-image-path?imagePath=${encodeURIComponent(imagePath)}&sec=${encodeURIComponent(sec)}`;
//   console.log("Request URL:", url); // 이 URL을 브라우저에서 직접 접속해보세요
//   try {
//     const response = await axios.get(url);
//     if (response.data.url) {
//       return response.data.url;
//     } else {
//       return '';
//     }
//   } catch (error) {
//     console.error('Error fetching image URL:', error);
//     return '';
//   }
// }



// async function fetchImageUrl(imagePath, sec) {

//   console.log(imagePath, '==== local imagePath');
//   try {
//     const response = await axios.get(`https://kuebs.org/api/get-image-path`, {
//     // const response = await axios.get(`http://127.0.0.1:8000/get-image-path`, {
//       params: { imagePath, sec } // 쿼리 파라미터로 imagePath 전달
//     });
//     if (response.data.url) {
//       return response.data.url; // 성공적으로 URL 반환
//     } else {
//       return ''; // URL이 없는 경우 빈 문자열 반환
//     }
//   } catch (error) {
//     console.error('Error fetching image URL:', error);
//     return ''; // 오류 발생 시 빈 문자열 반환
//   }
// }



// function fetchImageUrl(imagePath, sec) {
//     fnc.sendAxiosGet(`http://localhost:8000/get-image-path`, { imagePath, sec }, (res) => {
//           if (res) {
//             console.log(res, 'res');
//           } else {
//               console.log(res, "fncSelect_exam_list_complete");
//           }
//     });
// };


  
const fncS4 = { 
  getS3Path, getS3PathLong, getS3PathShort, getS3PathVideo, getS3PathDownLoad_rename, axiosPutFile
 }

export default fncS4;
// module.exports = fnc;
// 
